import {Article} from "./article";
import {PricingItem} from "./pricing-item";
import { bigToString, parseBig } from 'src/app/core/utils/math-utils';
import Big from 'big.js';
import { EnumPricingItemType } from "quote-export-manager-core";

export class DevicePricingItem extends PricingItem {

    constructor(public readonly device?: Article,
        public readonly collectorExtraPrice?: string,
        public readonly oldCollectorExtraPrice?: string) {
        super();
    }

    get initialStockLS() {
        const exchangeRuleValue = this.userInputs.exchangeRule?.value;
        if (!exchangeRuleValue || exchangeRuleValue === 'aucun') {
            return null;
        }
        try {
            const quantity = new Big(this.userInputs.quantity || 0);
            const exchangeRule = new Big(eval(exchangeRuleValue));
            return bigToString(quantity.div(exchangeRule).round(), 0);
        } catch (error) {
            console.error("Error evaluating exchanges rule:", error);
            return null;
        }
    }

    get initialstockBillLS() {
        if (this.pricingItemType == EnumPricingItemType.DEVICE) {
        const initialStock = this.initialStockLS;
        return bigToString(parseBig(initialStock).mul(parseBig(this['device'].appliedPrice)),3);
        }
    }

    get unitStockInitialVT() {
        if (this.isCmc) {
            return Number(this.userInputs['stockVT']?.value);
        } else {
            const stockVT = this.userInputs['stockVT'];
            if (typeof stockVT === 'object' && stockVT !== null) {
                return Number(this.userInputs['stockVT']?.value);
            }
            return this.userInputs['stockVT'];
        }
    }

    get totalStockInitialVT(): string | null {
        const userInput = this.userInputs['numberOfChange']?.value;
        if (!userInput) return null;
        const numberOfChange = Number(userInput);
        // Check if the input is NaN and is equal to "groupé"
        if (isNaN(numberOfChange) && 'groupé' === userInput.toLowerCase()) {
            const quantity = new Big(this.userInputs.quantity|| 0);
            return bigToString(quantity, 0);
        }

        // Check if the input is a positive number
        if (numberOfChange > 0) {
            const initialStockVT = this.unitStockInitialVT ? this.unitStockInitialVT : '0';
            const quantity = new Big(this.userInputs.quantity || 0);
            return bigToString(quantity.mul(new Big(initialStockVT)), 0);
        }
        return null;
    }

}
